import {observable, action} from 'mobx';
import _ from 'lodash';

class MCQThemesStore {
  @observable mcq_themes = [];
  @observable mcq_theme = _.assign({}, {
    title: '',
  });

  @action
  setMcqThemes = (themes) => {
    this.mcq_themes = themes;
  };
  @action
  setMcqTheme = (theme) => {
    this.mcq_theme = theme;
  };

  @action
  initNewMcqTheme = () => {
   this.mcq_theme = _.assign({}, {
      title: '',
    });
  };

  @action
  setError = errors => {
    this.errors = errors;
  };

  @action
  saveMcqTheme = theme => {
    const themes = [...this.mcq_themes];
    themes.push(theme);
    this.setMcqThemes(themes);
  }

  @action
  handleChange = data => {
    _.assign(this.mcq_theme, data);
  };
};

export default new MCQThemesStore();



// WEBPACK FOOTER //
// ./src/stores/MCQThemesStore.js